
import React, {AnchorHTMLAttributes, FC} from 'react';
import classNames from 'classnames';
import {LINK_EXT} from 'constants/index';

import {Variant, vClass} from './variants';

import * as styles from './styles.module.scss';

interface LinkProps extends AnchorHTMLAttributes<object> {
	children?: string;
	className?: string;
	external?: boolean;
	variant: Variant;
}

export const Link: FC<LinkProps> = (props) => {
	const {children, className: cn, external, variant, ...rest} = props;
	const className = classNames(styles.link, cn, vClass(variant));

	let inner = {...rest};
	if (external) {
		inner = {
			...inner,
			...LINK_EXT(),
		};
	}

	return (
		<a className={className} {...inner}>
			{children}
		</a>
	);
};
